
<script setup lang="ts">
import DownloadBanner from '@c/common/h5/DownloadAppBanner.vue';
import GlossaryDetail from './components/Detail.vue';
import GlossaryRecommend from './components/Recommend.vue';
import GlossaryFooter from './components/Footer.vue';
import { useGlossary } from './hooks';
import { isPC } from '@/utils/tools';
import { isApp } from '@/utils/appBridge';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const isM = !isPC();

// 使用路由获取当前术语参数
const route = useRoute();
const termSlug = route.params.term as string;

// 使用术语库组合式函数
const { getTermBySlug, showDownload } = useGlossary();

// 获取当前术语信息
const currentTerm = computed(() => getTermBySlug(termSlug));

watch(currentTerm, () => {
  if (currentTerm.value) {
    document.title = t('glossary.term_title', { title: currentTerm.value.title });
    document.querySelector('meta[name="description"]')?.setAttribute('content', currentTerm.value.subtitle);
  }
}, { immediate: true });
</script>

<template>
  <div :class="[isM ? '' : 'w-1200px mx-auto py-56px']">
    <div
      class="flex flex-col"
      :class="[isM ? 'm-body' : 'body', isApp ? 'app-body' : '']"
    >
      <DownloadBanner v-if="showDownload" />
      <!-- 术语详情 -->
      <GlossaryDetail
        :term="currentTerm"
        :is-m="isM"
      />

      <!-- 推荐术语 -->
      <GlossaryRecommend
        :items="currentTerm?.recommend"
        :is-m="isM"
      />
    </div>
    <GlossaryFooter :is-m="isM" />
  </div>
</template>
<style lang="scss">
html {
  min-width: 100%;
}
</style>
<style scoped lang="scss">
.body {
  min-height: calc(100vh - 575px);
}
.m-body {
  min-height: calc(100vh - 148px);
}
.app-body {
  min-height: calc(100vh - 48px) !important;
}
</style>
